import { Box, Button, Container, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PageMeta from '../components/PageMeta';

export default function HowToPlay() {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md">
      <PageMeta
        title="How to Play | Anime Opening Quiz"
        description="How rounds, difficulty levels and scoring work in Anime Opening Quiz."
        path="/how-to-play"
      />
      <Box component="main" sx={{ py: 5 }}>
        <Typography variant="h3" component="h1">How to play</Typography>
        <Typography paragraph>
          Pick a mode, listen to the opening and search for the anime title before the
          15-second timer runs out. Select an answer from the search results to submit it.
        </Typography>

        <Typography variant="h5" component="h2" sx={{ mt: 4, mb: 1 }}>Single player</Typography>
        <Typography paragraph>
          Choose the number of rounds and one or more difficulty levels. A correct answer is
          worth 10 points on Easy, 15 on Medium and 20 on Hard, with up to 5 extra points for
          a fast answer. Titles are not repeated within the same session.
        </Typography>

        <Typography variant="h5" component="h2" sx={{ mt: 4, mb: 1 }}>Multiplayer</Typography>
        <Typography paragraph>
          Create a room and share its code. Everyone hears the same opening and submits an
          answer independently. The scoreboard updates after each round.
        </Typography>

        <Typography variant="h5" component="h2" sx={{ mt: 4, mb: 1 }}>Difficulty</Typography>
        <Typography paragraph>
          Easy contains widely recognised series. Medium covers familiar but less obvious
          titles. Hard draws from more niche series in the database. Difficulty describes
          how recognisable a title is, not the age of the anime.
        </Typography>

        <Typography variant="h5" component="h2" sx={{ mt: 4, mb: 1 }}>About the selection</Typography>
        <Typography paragraph>
          The current pool contains 508 openings from 434 anime. The list is maintained by
          hand; duplicate titles, endings and unavailable videos are removed when found.
          Playback uses the official YouTube embedded player.
        </Typography>

        <Button variant="contained" onClick={() => navigate('/singleplayer')} sx={{ mt: 2 }}>
          Play single player
        </Button>
      </Box>
    </Container>
  );
}
